import { render, staticRenderFns } from "./PageInputs.vue?vue&type=template&id=6d78a9c0&"
import script from "./PageInputs.vue?vue&type=script&lang=ts&"
export * from "./PageInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports